"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.knowledge.updated': '头像知识库更新成功',
    'avatar.knowledge.load.error': '加载头像知识失败',
    'avatar.knowledge.update.error': '更新头像知识失败',
};
